import {Directive, ElementRef, HostListener, Inject, inject, OnDestroy, Self, ViewContainerRef} from '@angular/core';
import {cloneDeep, extend, filter, find, findIndex, forEach, get, indexOf, isString} from "lodash-es";
import {BaseComponent, getWidgetRegistry, propFactory as PropertiesFactory, WidgetRef} from "@wm/components-base";
import {getDecodedData, getValidJSON, isDefined, noop, runtimeEventManager} from "@wm/core";
import {Subscription} from "rxjs";

enum ComponentType {
  PAGE,
  PREFAB,
  PARTIAL
}
let partialParams: any = [];

let partialName: string = '';
let el = '';
let pageservice: any;
let pageWSservice: any;
@Directive({
  selector: '[pageContainer], [partialContainer]',
  standalone: true
})
export class PageContainerDirective implements OnDestroy {
  private _el: any;
  private overlayContent: any;
  private widget: any;
  private prefabname: string | undefined;
  private target: any;
  private toolbar: { addClass: (arg0: string) => void; removeClass: (arg0: string) => void; };
  private overlay: { addClass: (arg0: string) => void; removeClass: (arg0: string) => void; };
  private isPrefabParent: boolean;
  private pageParams: any;
  loadedPartials: { [key: string]: any } = {};
  listPartials: any[] = [];
  filteredPartials: string | any[];
  private registerDestroyListener = new Subscription();
  public partialParams: any = [];
  public vcRef: ViewContainerRef;
  private prefabName: string | undefined;
  private $target: any;
  private contentInitialized: boolean;
  private pages = [];
  private resourceMngr: any;
  private prefabResourceMngr: any;
  private projectService: any;


  @HostListener('click', ['$event'])
  _openPageWS($event: any) {
    let target = $($event.target);
    if (target.hasClass('wm-edit') || target.hasClass('wm-included-page-heading') || target.hasClass('content-overlay active')) {
      runtimeEventManager.emit('loadPage', this.widget.content);
    }
  }

  constructor(@Self() @Inject(WidgetRef) public componentInstance: BaseComponent) {
    const elementRef = inject(ElementRef);
    this.vcRef = inject(ViewContainerRef);
    this._el = elementRef.nativeElement;
    this.widget = this.componentInstance;
    this.widget['page-container'] = true;
    let pageConatinerWp = PropertiesFactory.getPropertiesOf('wm.pagecontainer');
    this.widget.widgetProps = extend({}, this.widget.widgetProps, pageConatinerWp);
    this.projectService = runtimeEventManager.getService('projectService');
    pageservice = runtimeEventManager.getService('pageService');
    pageWSservice = runtimeEventManager.getService('pageWSService');
    this.resourceMngr = runtimeEventManager.getService('AppResourceManagerService');
    this.prefabResourceMngr = runtimeEventManager.getService('AppPrefabResourceManagerService');
    this.widget._partialParams = {};

    this.componentInstance.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === 'content') {
        if('isInlineContent' in this.componentInstance) {
          this.componentInstance.isInlineContent = !(nv && nv !== '');
        }
        if (nv === ov) {
          return
        }
        nv = this.widget.content;
        // @ts-ignore
        let pageInfo = find(pageservice.getPages(), { name: nv });
        partialParams = cloneDeep(get(pageInfo, 'params'));
        this.partialParams = partialParams;

        // TODO if the $lazyLoad is method is defined on the iScope of the widget (eg, tabContent and accordionContent) and if the widget is not active
        // load the page on-demand(lazily) otherwise load immediately
        if (nv && (this.componentInstance as any).$lazyLoad && !(this.componentInstance as any).isActive) {
          // override the $lazyLoad method defined on the iScope.
          // page will be loaded only when this method is triggered.
          (this.componentInstance as any).$lazyLoad =  () => {
            let forceLoad = this.componentInstance.widgetType === 'wm-popover';
            this.onPageIncludeChange(nv);
            if (!forceLoad) {
              // page is loaded successfully. reset the $lazyLoad to WM.noop. executing this method multiple times will do nothing.
              (this.componentInstance as any).$lazyLoad = noop;
            }
          };
        } else {
          this.onPageIncludeChange(nv);
        }
        this.loadPartialParamProperties();
      } else if (key === 'active') {
        if (!this.toolbar) {
          return;
        }
        if (nv) {
          this.toolbar.addClass('active');
          this.overlay.addClass('active');
        } else {
          this.toolbar.removeClass('active');
          this.overlay.removeClass('active');
        }
      }
    });
  }

  evtHandler(e: Event) {
    // Do not allow the drop event when this widgets content is set to other page.
    e.stopPropagation();
    e.preventDefault();
  }

  bindEvtHandler(element: JQuery<HTMLElement>) {
    element.on('drop', this.evtHandler);
  }

  unbindEvtHandler(element: JQuery<HTMLElement>) {
    element.off('drop');
  }

  registerParams(name: string, value: string) {
    forEach(partialParams, (param) => {
      if (param.name === name) {
        param.value = value;
      }
    });
  }


  async onPageIncludeChange(newVal: string) {
    let target = this.target,
      page = 'pages/' + newVal + '/',
      $s = this.componentInstance, // iscope
      element = $(this._el),
      addToolBar,
      $parent = this.componentInstance.viewParent; // iScope.$parent

    if (!target || !target.length) {
      if (this._el.hasAttribute('page-container-target')) {
        target = element;
      } else {
        target = element.find('[page-container-target]');
      }
      this.target = target;
    }

    element.attr('content', newVal);
    target.find('.app-included-page, .app-included-page + .content-overlay, .wm-included-page-heading').remove();

    if (isString(newVal) && newVal.trim().length) {
      /*load the partial on-demand*/
      let updatedPartialName = newVal;
      // TODO
      // if ($(element).closest('.app-prefab').length || (iScope.$parent && iScope.$parent.prefabname)) {
      //   updatedPartialName = ($(element).closest('.app-prefab').attr('prefabname') || (iScope.$parent && iScope.$parent.prefabname)) + newVal;
      // }
      if (!this.loadedPartials[updatedPartialName]) {
        this.widget.Widgets = {};
        this.bindEvtHandler(element);
        addToolBar = isDefined(this._el.getAttribute('widgetid'));

        /* check for addToolBar*/
        if (addToolBar) {
          this.overlayContent = '<button class="wm-included-page-heading button-primary" title="edit ' + newVal + '"><i class="wm-edit wi wi-pencil"></i></button>';
        }
        /*read the file content*/
        // let path = "../../../" + page + 'page.min.json';
        let path = `/studio/services/projects/${this.projectService.getProjectId()}/${page}page.min.json`;

        let $promise;
        // TODO partials within a prefab should be fetched from the prefab project
        let $prefabEl = $(element).closest('.app-prefab').length ? $(element).closest('.app-prefab') : $(element).closest('section[wmPrefab]');
        if ($prefabEl.length || ($parent && get($parent, 'prefabName'))) {
          this.prefabname = $prefabEl.attr('prefabname') || ($parent && get($parent, 'prefabName'));
          $promise = this.prefabResourceMngr.getPageDataForPrefab(this.prefabname, newVal);
        } else {
          $promise = this.resourceMngr.get(path, true)
        }

        return $promise.then((pageContent: any) => {
          pageContent = isString(pageContent) ? JSON.parse(pageContent): pageContent;
          let $styles = getDecodedData(pageContent.styles),
            pageContentObj;
          // $(document.head).append('<style>' + $styles + '</style>');
          const sandboxWrapper = document.querySelector('wms-canvas-sandbox-wrapper');
          if (sandboxWrapper && sandboxWrapper.shadowRoot && $styles) {
              const styleElement = document.createElement('style');
              styleElement.textContent = $styles;
              sandboxWrapper.shadowRoot.appendChild(styleElement);
          }
          pageContentObj = {
            html: getDecodedData(pageContent.markup),
            variables: getValidJSON(getDecodedData(pageContent.variables)) || {},
            css: $styles
          };
          this.onPageFetchSuccess(pageContentObj, this.prefabname);
        }, this.onPageFetchError.bind(this));
      } else {
        /* to compile the partial page*/
        this._compilePartialAndUpdateVariables(updatedPartialName, this.overlayContent);
      }
    } else {
      this.widget.Widgets = undefined;
      if (this.componentInstance.widgetType === 'wm-top-nav' && !element.children().length) {
        // TODO:
        // $rootScope.$emit('canvas-add-widget', {
        //   widgetType: 'wm-list',
        //   parentName: iScope.name
        // }, true);
        // this.eventManager.emitOnCanvasAdd({
        //   widgetType: 'wm-list',
        //   parentName: this.componentInstance['widget'].name
        // });
      }
      element.find('> .app-partial-info').remove();
      this.unbindEvtHandler(element);
    }
  }


  _compilePartialAndUpdateVariables(partialName: string, partialMarkup: string, prefabName?: string) {
    setTimeout(() => {
      this.compilePartialAndUpdateVariables(partialName, partialMarkup, prefabName);
    });
  }

  compilePartialAndUpdateVariables(partialName: string, partialMarkup: string, prefabName?: string) {
    let iScope = this.componentInstance;
    let element = this._el;
    let target = this.target,
      scope;

    /* set the partial-page variables (will be registered by the partial) */
    // Variables.setPageVariables(partialName, loadedPartials[partialName].variables);

    /* append the pageContentMarkup to original markup, to compile it manually*/
    partialMarkup = partialMarkup + '<div class="app-included-page">' + (this.loadedPartials[partialName].html || '') + '</div>';

    /* wm-livelist and wm-login elements will have ngController directive this will result in
     * error:multidir Multiple Directive Resource Contention
     * to resolve this issue,
     * RunMode: remove the ngController directive from the element and add a wrapper with the controller name
     * StudioMode: remove the ngController directive
     */
    partialMarkup = partialMarkup + '<div class="content-overlay"></div>';
    let $partialMarkup = $(partialMarkup);
    // $partialMarkup.find('wm-list, wm-login').removeAttr('data-ng-controller');
    if (prefabName) {
      // $rootScope.$emit('partial-show-at-widget', {
      //   markup: partialMarkup,
      //   partialName: _.split(partialName, prefabName)[1],
      //   prefabName: prefabName
      // });
    }

    /*get the element scope*/
    scope = this.componentInstance;

    /* pre-compile */
    this.preCompilePartial($partialMarkup);
    this.componentInstance['widget'].partialname = partialName;
    this.componentInstance['widget'].partialcontainername = this.componentInstance['widget'].name;
    this.componentInstance['widget'].pageParams = this.pageParams;
    this.componentInstance['widget'].isPrefabParent = this.isPrefabParent;
    if (this.componentInstance.widgetType === 'wm-popover') {
      // TODO popover template
      // let popoverTemplate = 'template/popoverPartials/' + iScope.$id + '.html';
      // $tc.put(popoverTemplate, '<div>' + partialMarkup[0].outerHTML + '</div>');
      // iScope._popoverOptions.contenturl = popoverTemplate;
    } else {
      target.html(partialMarkup);
      this._renderPartial(this.widget.content);
    }

    // Check if the partial is been used multiple times. If so, then do not clear the loadedPartials as it is used in next iteration.
    this.filteredPartials = filter(this.listPartials, (partial: any) => {
      return (partial === partialName);
    });
    this.listPartials.splice(indexOf(this.listPartials, partialName), 1);

    if (this.filteredPartials.length === 1) {
      /*reset loaded partials, as they contain the htmlMarkup & variables*/
      this.loadedPartials[partialName] = undefined;
    }

    this.toolbar = target.find('button.wm-included-page-heading').first();
    this.overlay = target.find('div.content-overlay').first();

    // TODO scope.$emit('on-pagecontainer-ready');
  }

  /* before compilation of the partial content*/
  preCompilePartial(partialElement: JQuery<HTMLElement>) {
    // TODO:
    /* any of the partial children having on-click attr as goToPage- navigation call, remove 'active' class on it*/
    partialElement.find('[on-click^="goToPage-"][on-click^="goToPage_"]').removeClass('active');
    /*get active-page & get the element goToPage-ActivePage navigation call, add 'active' class on it*/
    // partialElement.find('[on-click="goToPage-' + ($rootScope.activePageName) + '"][on-click="goToPage_' + ($rootScope.activePageName) + '"]').addClass('active');
  }

  onPageFetchSuccess(content: any, prefabName?: string) {
    let newVal = this.widget.content;
    if (newVal) {
      /*get individual file contents like - html/js/css */
      let updatedPartialName: string = prefabName ? prefabName + newVal : newVal;
      this.loadedPartials[updatedPartialName] = content;

      this.listPartials.push(updatedPartialName);
      if (prefabName) {
        this.isPrefabParent = true;
      }
      /* to compile the partial page*/
      this._compilePartialAndUpdateVariables(updatedPartialName, this.overlayContent, prefabName);
    }
  }
  onPageFetchError() {
    if (this._el.hasAttribute('page-container-target')) {
      this.target = $(this._el);
    } else {
      this.target = $(this._el).find('[page-container-target]').first();
    }
    this.target.html('<div class="app-partial-info"><div class="partial-message">Content for the container is unavailable.</div></div>');
  }


  // Here, iScope.partialParams is equal to this.widget.partialParams
  loadPartialParamProperties() {
    let partiaParams = partialParams,
      paramName,
      element = this._el,
      iScope = this.widget;

    if (iScope.newcolumns) {
      iScope.newcolumns = false;
      this.widget._partialParams = {};
      runtimeEventManager.emit('partial-container-params-modified', { params: this.partialParams, widgetName: this.widget.name, content: this.widget.content });
    }
    // loop over each partial param, and append a property object against the widget scope
    forEach(partialParams, (param) => {
      if (!find(partialParams, {name: param.name}))
      partialParams.push({'name': param.name, 'value': '', 'type': param.type});
    });
    forEach(this.widget._partialParams, (value: any, key: string) => {
      let i = findIndex(this.partialParams, { name: key });
      if (i !== -1 && this.partialParams[i].value !== value) {
        this.partialParams[i].value = value;
      } else {
        delete this.widget._partialParams[key];
      }
      runtimeEventManager.emit('partial-container-params-modified', { params: this.partialParams, widgetName: this.widget.name, content: this.widget.content });
    });
    this.widget.partialParams = this.partialParams;
  }

  _renderPartial(partialName: string, options?: string) {
    if (!partialName) {
      return;
    }
    // destroy the existing partial
    /*WMS-26099 Do not clear vc for pagedialog as it removing everything inside the dialog(header, body, footer)
    vc target is inside the dialog body and we are clearing (target.innerHTML = '') target bofore appending the partial content in 'compilePartial' function*/
    if(this.widget.widgetType !== 'wm-pagedialog') {
      this.vcRef.clear();
    }
    // when the container-target is inside the component template, it can be queried after viewInit of the component.
    // $invokeWatchers(true);
    // for partials with popovers and page dialogs which are inside a prefab, prefab name needs to be computed and appended
    const prefab = $(this._el).closest('.app-prefab');
    if (prefab.length) {
      this.prefabName = prefab.attr('prefabname');
    } else if (this.componentInstance.viewParent) {
      this.prefabName = get(this.componentInstance.viewParent, 'prefabName');
    }
    this.compilePartial(partialName, { prefab: this.prefabName, widgetRef: this.componentInstance });
  }

  compilePartial(partialName: string, options?: { [key: string]: any }) {
    runtimeEventManager.getService('componentRefProvider').getComponentFactoryRef(partialName, ComponentType.PARTIAL, options)
      .then((componentRef: any) => {
        if (componentRef) {
          const instanceRef = componentRef;
          if (instanceRef && instanceRef['_component'] && this.prefabName) {
            instanceRef['_component'].prefabName = this.prefabName;
          }
          let target = this._el.querySelector('.app-included-page') || this._el.querySelector('[partial-container-target]') || this._el;

          target.innerHTML = '';
          const content = instanceRef.location.nativeElement;
          // remove the dotted outline on the widgets inside partial, when rendered on the page.
          const elementsWithAttr = content.querySelectorAll('[widgetid]');
          const registry = getWidgetRegistry();
          elementsWithAttr.forEach((el: HTMLElement) => {
            const widgetId = el.getAttribute('widget-id');
            widgetId && registry.delete(widgetId);
            el.removeAttribute('widgetid'); // remove the attribute
            el.removeAttribute('widget-id');
          });
          target.appendChild(instanceRef.location.nativeElement);
          this.contentInitialized = true;
          setTimeout(() => this.onLoadSuccess(partialName));
        }
      })
  }

  onLoadSuccess(partialName: string) {
    // this.app.notify('partialLoaded'); emit event to reload focus rect position - only partials loaded inside dnd canvas widgets
  }

  ngOnDestroy() {
    this.registerDestroyListener.unsubscribe();
    // runtimeEventManager.off();
  }
}
